import React from 'react'
import { render, screen } from '@testing-library/react'
import BadgeCard from '@toasttab/shared/src/components/molecules/CardTypes/BadgeCard'
import { BadgeCardProps } from '../types.d'

const baseProps: BadgeCardProps = {
  images: {
    imageResolutions: [
      {
        desktop: [
          {
            exension: 'png',
            url: 'https://d2w1ef2ao9g8r9.cloudfront.net/images/demo@2x.png',
            title: 'demo',
            optimizedImages: {
              srcAvif:
                'https://d2w1ef2ao9g8r9.cloudfront.net/images/_1600x1575_crop_center-center_82_line/demo@2x.png.webp'
            }
          }
        ],
        tablet: [],
        mobile: []
      }
    ]
  },
  heading: 'Heading',
  description:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vitae pulvinar ante. Etiam vel lacus ut mauris sodales pharetra.'
}

describe('Badge Card Tests', () => {
  it('Should Render BadgeCard', () => {
    render(<BadgeCard {...baseProps} />)

    // Get BadgeCard container element by id
    const badgecard = screen.getByTestId('badgecard')
    expect(badgecard).toBeTruthy()

    // Get H5 element
    const heading = screen.getByRole('heading', { level: 5 })
    expect(heading).toBeTruthy()
    expect(heading.classList.contains('text-color-primary')).toBe(true)
    expect(heading.textContent).toBe('Heading')

    // Get Paragraph element By querySelector
    const description = screen.getByText(
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vitae pulvinar ante. Etiam vel lacus ut mauris sodales pharetra.'
    )
    expect(description).toBeTruthy()
    expect(description.classList.contains('text-color-secondary')).toBe(true)
  })
})
